import { render, staticRenderFns } from "./orgRemittancesRanked.vue?vue&type=template&id=0362ce8a&scoped=true&"
import script from "./orgRemittancesRanked.vue?vue&type=script&lang=js&"
export * from "./orgRemittancesRanked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0362ce8a",
  null
  
)

export default component.exports